module.exports = __webpack_public_path__ + "assets/11a0164ba3c072969bfb5f72f62daab5.png";